
  import { defineComponent } from 'vue';
  import { RouteLocationNormalized } from 'vue-router';
  import { mapActions } from 'vuex';

  import DashboardLayout from '@/common/ui/layout/DashboardLayout.vue';

  import auditPage from '@/modules/admin/api/auditPage';

  export default defineComponent({
    name: 'App',
    components: {
      DashboardLayout,
    },
    computed: {
      layoutComponentName() {
        return 'DashboardLayout';
      },
    },
    data() {
      return {};
    },
    created() {
      this.loadUser();
    },
    methods: {
      ...mapActions('auth/oidc', ['loadUser']),
    },
    watch: {
      $route: function (to: RouteLocationNormalized, from: RouteLocationNormalized) {
        if (to.matched && to.matched.length > 0 && from.path !== to.path) {
          let request = {
            url: window.location.href,
            isInternal: true,
            routeName: to.name,
          };
          auditPage.visitPage(request);
        }
      },
    },
  });
